var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import scrollIntoView from "scroll-into-view-if-needed";
import { Description, Url } from "@irati-web/fields/companyNews";
import Icon from "../Template/Icon";
import TemplateTitle from "../Template/Title";
import TemplateFindOutMore from "../Template/FindOutMore";
import { StyledTemplatesCol, StyledTemplate, StyledSvgCard } from "../Template/styled";
var templateLibrary = [
    {
        backgroundColor: "#EE6352",
        templateIcon: "calendar",
        templateText: "platform.homepage.companyNews.template.companyCalendar"
    },
    {
        backgroundColor: "#7856E7",
        templateIcon: "announcement",
        templateText: "platform.homepage.companyNews.template.announcement"
    },
    {
        backgroundColor: "#EAC900",
        templateIcon: "event",
        templateText: "platform.homepage.companyNews.template.companyEvent"
    },
    {
        backgroundColor: "#21A0A0",
        templateIcon: "values",
        templateText: "platform.homepage.companyNews.template.companyValues"
    },
    {
        backgroundColor: "#F1BB6C",
        templateIcon: "party",
        templateText: "platform.homepage.companyNews.template.party"
    },
    {
        backgroundColor: "#FF5555",
        templateIcon: "people",
        templateText: "platform.homepage.companyNews.template.employeeReferral"
    },
    {
        backgroundColor: "#95CDC7",
        templateIcon: "play-video",
        templateText: "platform.homepage.companyNews.template.perkbox"
    },
    {
        backgroundColor: "#B4BAC6",
        templateIcon: "reminder",
        templateText: "platform.homepage.companyNews.template.reminder"
    },
    {
        backgroundColor: "#0DB690",
        templateIcon: "clipboard",
        templateText: "platform.homepage.companyNews.template.volunteer"
    },
    {
        backgroundColor: "#00ADEE",
        templateIcon: "blog",
        templateText: "platform.homepage.companyNews.template.companyBlog"
    },
    {
        backgroundColor: "#4A90E2",
        templateIcon: "clock",
        templateText: "platform.homepage.companyNews.template.extraShifts"
    },
    {
        backgroundColor: "#4A7BB4",
        templateIcon: "newsletter",
        templateText: "platform.homepage.companyNews.template.newsletter"
    }
];
var NewTemplateTileForm = /** @class */ (function (_super) {
    __extends(NewTemplateTileForm, _super);
    function NewTemplateTileForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NewTemplateTileForm.prototype.componentDidMount = function () {
        var _a = this.props, companyNewsTileConfig = _a.companyNewsTileConfig, updateContent = _a.updateContent;
        if (!companyNewsTileConfig.backgroundColor) {
            var defaultTemplate = templateLibrary[0];
            updateContent(Object.assign({}, companyNewsTileConfig, __assign({}, defaultTemplate)));
        }
        else {
            // @ts-ignore
            scrollIntoView(document.getElementById("id-" + companyNewsTileConfig.templateIcon), { scrollMode: "if-needed" });
        }
    };
    NewTemplateTileForm.prototype.render = function () {
        var _a = this.props, companyNewsTileConfig = _a.companyNewsTileConfig, updateContent = _a.updateContent;
        return (React.createElement(Row, null,
            React.createElement(StyledTemplatesCol, { xs: 6 }, templateLibrary.map(function (template) { return (React.createElement("div", { key: template.backgroundColor, id: "id-" + template.templateIcon },
                React.createElement(StyledSvgCard, { color: template.backgroundColor, isSelected: companyNewsTileConfig.backgroundColor === template.backgroundColor, onClick: function () {
                        updateContent(Object.assign({}, companyNewsTileConfig, __assign({}, template)));
                    } },
                    React.createElement(StyledTemplate, null,
                        React.createElement(Icon, { icon: template.templateIcon }),
                        React.createElement(TemplateTitle, { templateText: template.templateText }),
                        React.createElement(TemplateFindOutMore, null))))); })),
            React.createElement(Col, { xs: 6 },
                React.createElement(Description, { onChange: function (message) {
                        var updatedContent = Object.assign({}, companyNewsTileConfig, { message: message });
                        updateContent(updatedContent);
                    }, value: companyNewsTileConfig.message }),
                React.createElement(Url, { onChange: function (url) {
                        updateContent(Object.assign({}, companyNewsTileConfig, { url: url }));
                    }, value: companyNewsTileConfig.url }))));
    };
    return NewTemplateTileForm;
}(Component));
export default NewTemplateTileForm;
